import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';

import { SolicitudHistorial } from '../workflow/my-requests/commons/interfaces/my-requests.interface';
import { RequestFormService } from '../home/services/request-form.service';
import { catchError, from, of } from 'rxjs';

export const DataRequestHistoryResolverService: ResolveFn<SolicitudHistorial[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const id = route.paramMap.get('id');
  return from(inject(RequestFormService).getRequestHistory(id)).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};